import { css } from 'styled-components';

import { BREAKPOINTS } from 'common/styles/style-constants';

export enum SCREEN_SIZES {
  WIDESCREEN = 'widescreen',
  DESKTOP = 'desktop',
  SMALL_DESKTOP = 'smallDesktop',
  TABLET = 'tablet',
  PHONE = 'phone',
}

const SCREEN_SIZE_MEDIA_QUERIES = {
  [SCREEN_SIZES.WIDESCREEN]: `min-width: ${BREAKPOINTS.widescreenMin}px`,
  [SCREEN_SIZES.DESKTOP]: `min-width: ${BREAKPOINTS.widescreenMin}px`, // Include widescreen in desktop styles
  [SCREEN_SIZES.SMALL_DESKTOP]: `(min-width: ${
    BREAKPOINTS.desktopMin
  }px) and (max-width: ${BREAKPOINTS.desktopMax}px)`,
  [SCREEN_SIZES.TABLET]: `(min-width: ${
    BREAKPOINTS.tabletMin
  }px) and (max-width: ${BREAKPOINTS.tabletMax}px)`,
  [SCREEN_SIZES.PHONE]: `max-width: ${BREAKPOINTS.mobileMax}px`,
};

export const applyStylesForScreenSize = (
  screenSizes: SCREEN_SIZES[],
  styles: ReturnType<typeof css>,
) => {
  if (!Array.isArray(screenSizes)) {
    throw new Error('screenSizes must be an array');
  }

  const sizeQueries = screenSizes
    .map((size) => {
      const query = SCREEN_SIZE_MEDIA_QUERIES[size];
      if (!query) {
        throw new Error(`Invalid screen size: ${size}`);
      }

      return css`
        @media (${query}) {
          ${styles}
        }
      `;
    })
    // css`` returns an array, so we need to join them
    .map((query) => query.join('\n'));

  return sizeQueries.join('\n');
};
